import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { IMAGE_OBSERVATIONS, FILES_NAMES, FILES_NAMES_DAMAGES, CATEGORIES_PICTURES } from '../../../../../../constants/app/inspection';
import TransformInspection from '../../../../../../lib/utils/transforms/inspection';
import InspectionTransform from '../../../../../../lib/utils/transforms/inspections';
import { STATUS_SERVICE } from '../../../../../../constants/app/services';

const closeSvg = <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" />
const ModalReturns = ({ open = false, handleClose, handleOk, picturesObserverd = [], status }) => {
let getLabelsReasons = [];
const pictures = picturesObserverd.length ? picturesObserverd.map((pic) => {
const type = pic.type && InspectionTransform.getPictureTitle(pic.type, CATEGORIES_PICTURES);
const img = pic.pictureCode && InspectionTransform.getPictureTitle(pic.pictureCode, FILES_NAMES) || pic.damageCode && InspectionTransform.getPictureTitle(pic.damageCode, FILES_NAMES_DAMAGES) || pic.accessoryCode && InspectionTransform.getPictureTitle(pic.accessoryCode, FILES_NAMES);
const reasons = pic.observationCode ? TransformInspection.getReasonObservation(pic.observationCode, IMAGE_OBSERVATIONS) : {label: ''};
getLabelsReasons = reasons.length && reasons.map(reasons => reasons.label);

        return (
                <div className="row gray-background m10">
                    <div className="col-sm-5 col-md-5 picObs p10">
                        <img src={pic.files[0].thumbnail} />
                    <div className="h3 fz13">{img.label}</div>
                    </div>
                    <div className="col-sm-5 col-md-5 text-md--light pt15">{getLabelsReasons && (getLabelsReasons.length > 0) ? getLabelsReasons.join(", ") : ''}</div>
                    <div className="col-md-2 pt15">
                        <span className="category-picture">{type.label}</span>
                    </div>
                </div>
            )
    })
    : []

	return (
		<Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true}>
			<div className="col-md-12">
				<span className="h2 mb10">Devolver solicitud al cliente</span>
				<div className="text-md--light mt10">
                    Por favor, revisa las imagenes y los motivos de devolución para que el cliente sepa cómo prodceder.
				</div>
                <div className="pictures-observeds mb10">
                    {pictures}
                </div>
				<div className="row">
					<div className="col-md-12">
						<button type="button" className="btn btn-primary mr10" disabled={status.returned === STATUS_SERVICE.INPROGRESS} onClick={handleOk}>Devolver</button>
						<button type="button" className="btn btn-outline-secondary" onClick={handleClose}>Cancelar</button>
					</div>  
				</div>
			</div>			
		</Modal>
	);
}
export default ModalReturns;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/returns/modal-return.js